export default {
    common: {
        email_address_long: 'E-Mail Adresse',
        email_address_short: 'E-Mail',
        phone_number: 'Telefon',
        fax_number: 'Fax',
        address: 'Adresse',
        country: 'Land',
        city: 'Stadt',
        post_code_short: 'PLZ',
        street_name_short: 'Straßen',
        street_name_long: 'Straßenname',
        street_number: 'Nr',
        additional_address_info_short: 'Adresszusatz',
        additional_address_info_long: 'Zusätzliche Adressinformation',
        country_austria: 'Österreich',
        country_germany: 'Deutschland',
        country_switzerland: 'Schweiz',
    },

    operator: {
        operator: 'Betreiber',
        general_tab: 'Stammdaten',
        invoices_tab: 'Rechnung',
        sms_quota_tab: 'SMS-Kontingent',
        additional_operators_tab: 'Zusätzliche Betreiber',
        company_club: 'Firma | Verein',
        name_label: 'Name',
        name_placeholder: 'Bezeichnung/Name',
        uid_number_label: 'UID',
        uid_number_placeholder: 'UID Nummer',
        fn_number_label: 'FN',
        fn_number_placeholder: 'FN 9999999X',
        zvr_number_label: 'ZVR',
        zvr_number_placeholder: 'ZVR Nummer',
        dvr_number_label: 'DVR',
        dvr_number_placeholder: 'DVR Nummer',
        homepage: 'Homepage',
        email_signature: 'Signatur E-Mail',
    }
};
